import { currencies } from '../constants';

export const pushLearnMoreInteraction = (items: Record<string, any>[]) => {
  dataLayer.push({
    event: 'minipdp_learn_more_interaction',
    event_location: 'Quick-View',
    ecommerce: {
      currency: currencies[ENVIRONMENT_REGION],
      value: 0,
      items,
    },
  });
};
